import user from '../helpers/user';
import { __ } from '../translations';
import h from '../helpers/common';
import { applyPluralization } from '../helpers/pluralization';

export default function useRewindDuration(item: { rights: { rewindBuffer: number } }) {
    if (h.getAppConfig()?.rewindDays?.enabled !== true || typeof item.rights?.rewindBuffer !== 'number') return '';

    const rewindTimeInHours = item?.rights?.rewindBuffer ?? 12;
    // const rewindTimeInHours = Math.min(user.getUserInfo().tierConfig.epgPreviousDays * 24, item.rights.rewindBuffer);

    // If for some reason 'rewindTimeInHours' is not a valid number, we will return empty string
    if (isNaN(rewindTimeInHours)) return '';

    const textInHours = applyPluralization(
        h.getLang(),
        rewindTimeInHours,
        __('rewind_time_in_hour'),
        __('rewind_time_in_hours')
    );
    const textInDays = applyPluralization(
        h.getLang(),
        Math.floor(rewindTimeInHours / 24),
        __('rewind_time_in_day'),
        __('rewind_time_in_days')
    );

    const availableRewind =
        rewindTimeInHours < 24
            ? rewindTimeInHours + ' ' + textInHours
            : Math.floor(rewindTimeInHours / 24) + ' ' + textInDays;

    return availableRewind;
}
